import React, { Component, Fragment } from 'react';

import './style.scss';

export default class HomePopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPopup: true,
            showFrame: false,
            storage: false,
            email: '',
            emailValid: true,
        };
    }
    componentDidMount() {
        if (localStorage.getItem('popup')) {
            this.setState({
                storage: true,
            });
        } else {
            this.setState({
                storage: false,
            });
        }
    }
    handleChange(e) {
        this.setState({
            email: e.target.value,
        });
    }
    handleSubmit(e) {
        e.preventDefault();
        // Check email address
        if (/^[a-zA-Z0-9.+]+@[a-zA-Z0-9]+\.[A-Za-z.]+$/.test(this.state.email)) {
            this.setState({
                showFrame: true,
            });
            this.setState({ emailValid: true });
        } else {
            this.setState({
                emailValid: false,
            });
        }
    }
    handleClose = e => {
        if (e.target.className === 'popup-container' || e.target.className === 'close-box') {
            localStorage.setItem('popup', true);
            this.setState({ storage: false });
        }
    };
    render() {
        if (typeof window !== 'undefined') {
            if (!localStorage.getItem('popup')) {
                return (
                    <div className="popup-container" onClick={e => this.handleClose(e)}>
                        <div
                            className={
                                this.state.showFrame || this.props.step === '2'
                                    ? 'frame popup'
                                    : 'popup'
                            }
                        >
                            {this.state.showFrame || this.props.step === '2' ? (
                                <Fragment>
                                    <iframe
                                        title="email-alerts"
                                        ref="iframe"
                                        allowtransparency="true"
                                        marginHeight="0"
                                        marginWidth="0"
                                        className="responsive padded email-alerts"
                                        id="ExternalWebContentExternalIFrame"
                                        src={
                                            'https://otp.tools.investis.com/clients/uk/jdsports3/cas/default.aspx?culture=en-GB&alertEmail=' +
                                            (this.state.email ? this.state.email : this.props.email)
                                        }
                                        frameBorder="0"
                                        height="450"
                                        width="100%"
                                    ></iframe>
                                    <div
                                        className="cancel"
                                        onClick={e => this.handleClose(e)}
                                    ></div>
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <h1>Welcome to JD Group</h1>
                                    <p>Sign up for Regulatory News Alerts &amp; Announcements</p>
                                    <div className="signup">
                                        <form>
                                            <input
                                                type="email"
                                                required
                                                placeholder="Enter your email address here"
                                                onChange={e => this.handleChange(e)}
                                                value={this.state.email}
                                                className={this.state.emailValid ? null : 'invalid'}
                                            />
                                            <input
                                                type="submit"
                                                value="Submit"
                                                onClick={e => this.handleSubmit(e)}
                                                disabled={this.state.email.length === 0}
                                            />
                                            {this.state.emailValid ? null : (
                                                <p className="error">
                                                    Please enter a valid email address.
                                                </p>
                                            )}
                                        </form>
                                    </div>
                                    <p className="close-box" onClick={e => this.handleClose(e)}>
                                        No thanks
                                    </p>
                                </Fragment>
                            )}
                        </div>
                    </div>
                );
            } else {
                return null;
            }
        } else {
            return null;
        }
    }
}
